import { Paginator } from "primereact/paginator";
import { useHistory } from "react-router-dom";
import { ModalProcessingTalma } from "../../common/components/ModalProcessingTalma/ModalProcessingTalma";
import { parse, stringify } from "query-string";
import { ReportAppointmentTurn } from "./ReportAppointmentTurn/ReportAppointmentTurn";
import { ReportTraceability } from "./ReportTraceability/ReportTraceability";
import { ReportVolante } from "./ReportVolante/ReportVolante";
import { Authorization } from "../../common/AuthorizationCpt";
import { StatusType } from "./AdminReportResource";
import {
  CITATION_REPORT,
  FLYERS_REPORT,
  PROCESSING,
  SUCCESS,
  TRACKING_REPORT,
} from "../../utils/valueStaticConstants";
import {
  REPORT_GET_APPOINTMENTS_REPORT,
  REPORT_GET_VOLANTES_REPORT,
} from "../../utils/permissionConstant";

interface Props {
  reportTypeName: string;
  statusEndpoint: StatusType;
  loadReportExecutor: any;
}

export const AdminReportTable = (props: Props) => {
  const { loadReportExecutor, reportTypeName, statusEndpoint } = props;
  const history = useHistory();

  return (
    <>
      <Authorization actions={[REPORT_GET_VOLANTES_REPORT]}>
        {reportTypeName === FLYERS_REPORT && (
          <ReportVolante
            loadReportExecutor={loadReportExecutor}
            statusEndpoint={statusEndpoint}
          />
        )}
      </Authorization>

      <Authorization actions={[REPORT_GET_APPOINTMENTS_REPORT]}>
        {reportTypeName === CITATION_REPORT && (
          <ReportAppointmentTurn
            loadReportExecutor={loadReportExecutor}
            statusEndpoint={statusEndpoint}
          />
        )}
      </Authorization>
      {reportTypeName === TRACKING_REPORT && (
        <ReportTraceability
          loadReportExecutor={loadReportExecutor}
          statusEndpoint={statusEndpoint}
        />
      )}

      <Authorization
        actions={[REPORT_GET_VOLANTES_REPORT, REPORT_GET_APPOINTMENTS_REPORT]}
      >
        {loadReportExecutor.status === SUCCESS && statusEndpoint === SUCCESS && (
          <>
            {loadReportExecutor.data.count > 0 && (
              <div className="flex-paginator">
                <Paginator
                  first={
                    (loadReportExecutor.params.page - 1) *
                    loadReportExecutor.data.page_size
                  }
                  rows={loadReportExecutor.data.page_size}
                  totalRecords={loadReportExecutor.data.count}
                  onPageChange={(e) => {
                    const targetPage =
                      e.first / loadReportExecutor.data.page_size;
                    const pathname = history.location.pathname;
                    const parsedParams = parse(history.location.search);
                    const stringifiedParams = stringify({
                      ...parsedParams,
                      page: targetPage + 1,
                    });
                    history.push(`${pathname}?${stringifiedParams}`);
                  }}
                />
              </div>
            )}
          </>
        )}
      </Authorization>

      <ModalProcessingTalma
        showProcessing={loadReportExecutor.status === PROCESSING}
      />
    </>
  );
};
